import type { Provider } from '@/types/allauth';

/** Branded product labels for OAuth provider buttons, keyed by allauth provider id. */
export const PROVIDER_LABELS: Record<string, string> = {
  google: 'Google Workspace',
  microsoft: 'Microsoft 365',
};

/** "Continue with <branded label>" — the standard OAuth button label. */
export function getProviderButtonLabel(provider: Provider): string {
  return `Continue with ${PROVIDER_LABELS[provider.id] ?? provider.name}`;
}
